// extracted by mini-css-extract-plugin
export var copyableField = "_n3-4";
export var customerBadge = "_n3-0";
export var customerInfoTitle = "_n3-2";
export var details = "_n3-1";
export var dropdownContainer = "_n3-5";
export var dropdownImage = "_n3-6";
export var editAssigneeForm = "_n3-a";
export var editButton = "_n3-3";
export var email = "_n3-7";
export var hidden = "_n3-d";
export var input = "_n3-8";
export var saveButton = "_n3-b";
export var shopifyIcon = "_n3-c";
export var suggestionBadge = "_n3-e";
export var suggestionText = "_n3-f";
export var username = "_n3-9";